
const actions = {
    CREATE_MDN_SWAP_REQUEST: 'CREATE_MDN_SWAP_REQUEST',
    CREATE_MDN_SWAP_REQUEST_SUCCESSFUL: 'CREATE_MDN_SWAP_REQUEST_SUCCESSFUL',
    CREATE_MDN_SWAP_REQUEST_FAILED: 'CREATE_MDN_SWAP_REQUEST_FAILED',

    createMdnSwapRequest: (data) => ({
        type: actions.CREATE_MDN_SWAP_REQUEST,
        payload: { data }
    }),
    createMdnSwapRequestSuccessful: (message) => ({
        type: actions.CREATE_MDN_SWAP_REQUEST_SUCCESSFUL,
        message
    }),
    createMdnSwapRequestFailed: (error) => ({
        type: actions.CREATE_MDN_SWAP_REQUEST_FAILED,
        error
    }),
};
export default actions;
